/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DevicesListAliases {
  ADD_DEVICES_CUSTOM_DYNAMIC_BUTTON = 'add-devices-custom-dynamic-button',
  AUTOCOMPLETE_TYPE_PRESENTATION = 'autocomplete-type-presentation',
  CHECKBOX_IS_FILTERING_BY_IN_PROGRESS = 'checkbox-isFilteringByInProgress',
  CONTEXTUAL_BAR = 'contextual-bar',
  DECK_DEVICES = 'deck-devices',
  DEVICES_CARD = 'devices-card',
  FETCH_DEVICES_LIST = 'fetch-devices-list',
  FIELD_TYPE_PRESENTATION = 'field-type-presentation',
  FILTER_DEVICES = 'filter-devices',
  FILTER_FIELD_IS_FILTERING_BY_IN_PROGRESS = 'filter-field-isFilteringByInProgress',
  FILTER_FIELD_RETROACTIVE_DAYS = 'filter-field-retroactive-days',
  FILTERED_LIST_DEVICES = 'filtered-list-devices',
  GLOBAL_ACTIONS_DEVICES = 'global-actions-devices',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_RETROACTIVE_DAYS = 'input-retroactive-days',
  LAYOUT_DEVICES_LIST = 'layout-devices-list',
  LEGENDS_DEVICES = 'legends-devices',
  MAPPER_TYPE_PRESENTATION = 'mapper-type-presentation',
  PANEL_GLOBAL_ACTIONS = 'panel-global-actions',
  TEXT_TYPE_PRESENTATION = 'text-type-presentation',
}
export { DevicesListAliases };
